import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/filter/box-open.svg'
import _imports_1 from '../../assets/filter/pencil-alt.png'


const _withScopeId = n => (_pushScopeId("data-v-90abe5b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column",
  id: "containerGeral"
}
const _hoisted_2 = {
  class: "d-flex flex-column",
  id: "containerCard"
}
const _hoisted_3 = { class: "d-flex flex-row justify-content-between align-items-center pb-8" }
const _hoisted_4 = {
  class: "d-flex flex-row gap-4",
  id: "btnsInd"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"22px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"height":"fit-content","width":"fit-content","font-size":"18px"},
  class: "m-0 fas fa-plus"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-around\" id=\"header\" data-v-90abe5b6><div class=\"col-3 d-flex justify-content-center align-items-center\" data-v-90abe5b6><span class=\"subtitulo\" id=\"titleList\" data-v-90abe5b6>NOME</span></div><div class=\"col-3 d-flex justify-content-center align-items-center\" data-v-90abe5b6><span class=\"subtitulo\" id=\"titleList\" data-v-90abe5b6>TIPO</span></div><div class=\"col-3 d-flex justify-content-center align-items-center\" data-v-90abe5b6><span class=\"subtitulo\" id=\"titleList\" data-v-90abe5b6>AÇÕES</span></div></div>", 1)
const _hoisted_8 = {
  key: 0,
  class: "card d-flex h-100 justify-content-center",
  id: "empty"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "msgPesquisa" }, "Sua pesquisa não retornou nenhum dado. Verifique os campos e tente novamente.", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "d-flex w-100 flex-column bg-white mb-5",
  style: {"border-radius":"0 0 10px 10px"}
}
const _hoisted_13 = {
  key: 0,
  class: "skeleton-results bg-white mb-5",
  style: {"border-radius":"0 0 10px 10px","list-style":"none","padding":"0"}
}
const _hoisted_14 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_15 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_16 = { class: "col-3 d-flex justify-content-center align-items-center gap-2" }
const _hoisted_17 = {
  key: 2,
  id: "results"
}
const _hoisted_18 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_19 = { class: "texto text-center px-1" }
const _hoisted_20 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_21 = { class: "texto text-center" }
const _hoisted_22 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ElSkeletonItem = _resolveComponent("ElSkeletonItem")!
  const _component_ElSkeleton = _resolveComponent("ElSkeleton")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ModalAdicionarMarca = _resolveComponent("ModalAdicionarMarca")!
  const _component_ModalEditarMarca = _resolveComponent("ModalEditarMarca")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Title, null, {
            default: _withCtx(() => [
              _createTextVNode("Gestão de Marcas")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              type: "button",
              text: "Voltar",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.history.back()))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              type: "button",
              text: "Adicionar Marca",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.abrirModalAddMarca())),
              style: {"white-space":"nowrap"}
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_7,
      (_ctx.prodFinded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
        : _createCommentVNode("", true),
      (_ctx.skeleton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.skeleton)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                  _createVNode(_component_ElSkeleton, {
                    loading: true,
                    animated: ""
                  }, {
                    template: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                        return _createElementVNode("li", {
                          key: 'sk-' + n,
                          class: "d-flex align-items-center py-2 border-bottom"
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_ElSkeletonItem, {
                              variant: "text",
                              style: {"width":"60%","height":"20px"}
                            })
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_ElSkeletonItem, {
                              variant: "text",
                              style: {"width":"50%","height":"20px"}
                            })
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ElSkeletonItem, {
                              variant: "rect",
                              style: {"width":"32px","height":"32px","border-radius":"4px"}
                            }),
                            _createVNode(_component_ElSkeletonItem, {
                              variant: "rect",
                              style: {"width":"32px","height":"32px","border-radius":"4px"}
                            })
                          ])
                        ])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcas, (item, key) => {
              return (_openBlock(), _createElementBlock("li", { key: key }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(item.nome), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(item.tipoProduto), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    class: "me-1",
                    onClick: () => { _ctx.abrirModalEditMarca(item) }
                  }, _hoisted_25, 8, _hoisted_23)
                ])
              ]))
            }), 128))
          ])),
      (_openBlock(), _createBlock(_component_Pagination, {
        ref: "pagination",
        key: _ctx.route.path,
        arr: _ctx.marcas,
        totalBanco: _ctx.totalMarcas,
        onPageChanged: _ctx.handlePageChange,
        tipo: 'Marcas encontradas'
      }, null, 8, ["arr", "totalBanco", "onPageChanged"]))
    ]),
    _createVNode(_component_ModalAdicionarMarca, { fechaModal: _ctx.fechaModalAddMarca }, null, 8, ["fechaModal"]),
    _createVNode(_component_ModalEditarMarca)
  ], 64))
}